// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.o031QoEAHNQqLCOKHQrh {
  width: 100px;
  height: 38px;
  border-radius: 18px;
  padding: 10px;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  font-family: var(--font-stack-full-regular);
}`, "",{"version":3,"sources":["webpack://./src/components/Table/ScoreColorFormatting/ScoreColorFormatting.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,2CAAA;AACF","sourcesContent":[".scoreColorFormattingContainer {\n  width: 100px;\n  height: 38px;\n  border-radius: 18px;\n  padding: 10px;\n  text-align: center;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: var(--font-stack-full-regular);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scoreColorFormattingContainer": `o031QoEAHNQqLCOKHQrh`
};
export default ___CSS_LOADER_EXPORT___;
